import React from "react";

// Small SVG icon set used across the redesign (24x24 stroke icons).
const ICONS = {
  arrow: ["M5 12h14M13 6l6 6-6 6"],
  check: ["M20 6 9 17l-5-5"],
  filter: ["M3 6h18M7 12h10M10 18h4"],
  clock: ["M12 7v5l3 2"],
  search: ["m20 20-3.5-3.5"],
  litigation: [
    "m14 13-7.5 7.5a2.1 2.1 0 0 1-3-3L11 10",
    "m16 16 6-6M8 8l6-6M9 7l8 8M21 11l-8-8",
  ],
  bell: [
    "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9",
    "M10.3 21a1.94 1.94 0 0 0 3.4 0",
  ],
  doc: [
    "M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z",
    "M14 3v5h5M9 13h6M9 17h4",
  ],
  chart: ["M3 3v18h18", "m7 15 4-4 3 3 5-6"],
  history: ["M3 12a9 9 0 1 0 3-6.7L3 8", "M3 3v5h5M12 7v5l3 2"],
  shield: ["M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z", "m9 12 2 2 4-4"],
};

// icons that also need a circle
const CIRCLES = {
  search: { cx: 11, cy: 11, r: 7 },
  clock: { cx: 12, cy: 12, r: 9 },
};

const Icon = ({ name, size = 18, color = "currentColor", strokeWidth = 2 }) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {CIRCLES[name] && <circle {...CIRCLES[name]} />}
    {ICONS[name].map((d) => (
      <path key={d} d={d} />
    ))}
  </svg>
);

export default Icon;
